import translations from './translations.js';

export default (
  twoFactorRequired,
  language = 'en_US',
) => {
  let data = {
    title: translations('title', language),
    submitText: translations('submitText', language),
    showCancelButton: true,
    cancelText: translations('cancelText', language),
    canClose: !twoFactorRequired,
  };
  return data;
};